import { HealthInsurance, InsuranceType } from '@/utils/constants.js';

interface TreatmentInsuranceFlags {
    public_insurance?: boolean;
    private_insurance?: boolean;
    self_payer?: boolean;
}

export const isTreatmentAvailableForInsurance = (
    treatment: TreatmentInsuranceFlags,
    selectedHealthInsurance: string | null | undefined
): boolean => {
    switch (selectedHealthInsurance) {
        case HealthInsurance.PUBLIC:
            return Boolean(treatment.public_insurance);
        case HealthInsurance.PRIVATE:
            return Boolean(treatment.private_insurance);
        case HealthInsurance.SELF_PAYER:
            return Boolean(treatment.self_payer);
        default:
            return false;
    }
};

/**
 * Normalizes various insurance type spellings to a canonical `InsuranceType` value.
 *
 * Accepts any case and the legacy `selfpayer` / `self-payer` spellings, and maps them
 * to one of `InsuranceType.PUBLIC`, `InsuranceType.PRIVATE`, or `InsuranceType.SELF_PAYER`.
 * Returns `undefined` for nullish, empty, or unknown inputs.
 */
export const formatInsuranceType = (
    type: string | null | undefined
): (typeof InsuranceType)[keyof typeof InsuranceType] | undefined => {
    const upperCaseInsuranceType = type?.toUpperCase() ?? '';
    const normalizedValue =
        upperCaseInsuranceType === 'SELFPAYER' || upperCaseInsuranceType === 'SELF-PAYER'
            ? 'SELF_PAYER'
            : upperCaseInsuranceType;

    if (normalizedValue in InsuranceType) {
        return InsuranceType[normalizedValue as keyof typeof InsuranceType];
    }

    return undefined;
};
